import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: 32,
        textAlign: 'center'
      }}
    >
      <h1 style={{ fontSize: 72, margin: 0, color: '#444' }}>404</h1>
      <h2 style={{ marginTop: 8, color: '#555' }}>Página não encontrada</h2>
      <p style={{ color: '#777', marginTop: 16, maxWidth: 480 }}>
        A página que você procura não existe ou foi movida. Verifique a URL ou volte para o início.
      </p>
      <Link
        to="/"
        style={{
          marginTop: 24,
          padding: '10px 24px',
          backgroundColor: '#1976d2',
          color: 'white',
          borderRadius: 4,
          textDecoration: 'none',
          fontWeight: 500
        }}
      >
        Voltar ao início
      </Link>
    </div>
  )
}

export default NotFound
